import { Tooltip } from 'primereact/tooltip';
import React from 'react';
import { isEmpty } from '../../../../utils/ValidForm';
import styles from './index.module.scss';
import { b64toBlob, download } from '../../../../utils/Exporter';

export default function ButtonDownload({
    fileName,
    formik,
    name,
    optionAnexo,
    disabled,
    optionName,
}) {
    const disableClass = fileName ? '' : styles.disableDownload;
    return (
        <>
            {isEmpty(disableClass) && (
                <Tooltip target={`.${name}`} position="top">
                    Baixar
                </Tooltip>
            )}
            <div
                className={`${styles.button} ${
                    disabled ? styles.hasDisable : ''
                } ${name} ${disableClass}`}
                onClick={() => {
                    if (isEmpty(disableClass)) {
                        const input = formik.values[name];
                        if (typeof input?.[optionAnexo] === 'string') {
                            b64toBlob(input?.[optionAnexo]).then((res) => {
                                download(res, input?.[optionName] ?? input?.name);
                            });
                        } else {
                            download(input, input?.[optionName] ?? input?.name);
                        }
                    }
                }}
            >
                <i className="pi pi-download"></i>
            </div>
        </>
    );
}
